import { MealOfDay } from 'fitbeat.models';

export class NutritionConfig {
    public static ingredientCategoryOrder: string[] = [
        'Produce',
        'Bread',
        'Dairy',
        'Meat',
        'Dry',
        'Beverages',
        'Canned',
        'Frozen',
    ];
    public static maxCategoryOrderNumber = 1000;

    public static MealCutOffTimeMap = new Map([
        [MealOfDay.Breakfast, 9],
        [MealOfDay.MorningSnack, 11],
        [MealOfDay.Lunch, 14],
        [MealOfDay.AfternoonSnack, 16],
        [MealOfDay.Dinner, 20],
      ]);
}
